import { Box, Divider, Typography } from "@bca/ui-library";
import React from "react";
import CTAs from "./CTAs";
import { Vehicle } from "../Interfaces/vehicle.type";
import BCA from "./Footers/BCA";
import PaymentFAQ from "./Footers/PaymentFAQ";
import PaymentDue from "./Headers/PaymentDue";
import PaymentFailed from "./Headers/PaymentFailed";
import PaymentProcessing from "./Headers/PaymentProcessing";
import InvoiceDescription from "./InvoiceDescription";
import InvoiceDetails from "./InvoiceDetails";
import InvoiceListItems from "./InvoiceListItems";
import InvoiceTotal from "./InvoiceTotal";

export const INVOICE_MODAL_TYPES = {
  INVOICE_PAID: {
    case: "INVOICE_PAID",
    header: null,
    footer: <BCA />,
  },
  PAYMENT_PROCESSING: {
    case: "PAYMENT_PROCESSING",
    header: <PaymentProcessing />,
    footer: <PaymentFAQ backgroundColor="rgba(254, 248, 248, 1)" />,
  },
  PAYMENT_FAILED: {
    case: "PAYMENT_FAILED",
    header: <PaymentFailed />,
    footer: <PaymentFAQ backgroundColor="rgba(254, 248, 248, 1)" />,
  },
  PAYMENT_DUE: {
    case: "PAYMENT_DUE",
    header: <PaymentDue />,
    footer: <PaymentFAQ backgroundColor="rgba(233, 245, 254, 0.5)" />,
  },
};

interface InvoiceModalContentProps {
  vehicleData: Vehicle;
  invoiceData: any;
  invoiceType?: string;
  openBankingLinkUrl: any;
  onClose: () => void;
}

const InvoiceModalContent: React.FunctionComponent<InvoiceModalContentProps> =
  ({
    vehicleData,
    invoiceData,
    invoiceType = INVOICE_MODAL_TYPES.INVOICE_PAID.case,
    openBankingLinkUrl,
    onClose,
  }) => {
    const ModalDivider = () => (
      <Box
        display="flex"
        height="10px"
        justifyContent="center"
        marginX={{
          mobile: "-20px",
          desktop: "0px",
        }}
      >
        <Divider orientation="horizontal" width="100%" />
      </Box>
    );
    return (
      <Box
        margin="0"
        display="flex"
        flexDirection="column"
        height="100%"
        overflowY="scroll"
      >
        {INVOICE_MODAL_TYPES[invoiceType].header}
        <Box
          marginX={{
            mobile: "20px",
            desktop: "48px",
          }}
          flexGrow={1}
        >
          <Typography variant="h4" color="grey-blue">
            Invoice
          </Typography>
          <InvoiceDescription
            vehicleData={vehicleData}
            invoiceData={invoiceData}
          />
          <ModalDivider />
          <InvoiceDetails vehicleData={vehicleData} />
          <ModalDivider />
          <InvoiceListItems invoiceData={invoiceData} />
          <ModalDivider />
          <InvoiceTotal invoiceData={invoiceData} />
          <CTAs
            vehicleData={vehicleData}
            invoiceData={invoiceData}
            openBankingLinkUrl={openBankingLinkUrl?.href}
            onClose={onClose}
          />
        </Box>
        {INVOICE_MODAL_TYPES[invoiceType].footer}
      </Box>
    );
  };

export default InvoiceModalContent;
